import React from "react";
 
const RadioGroupInput = ({ name, value, options, onChange }) => {
  return (
    <div className="form-row">
      {options?.map((opt) => (
        <div
          key={name + opt.value}
          className="col-sm col-sm-auto radio-box mb-3 pr-sm-0 pr-3 mr-1"
        >
          <input
            type="radio"
            name={name}
            id={name + opt.value}
            checked={value === opt.value}
            onChange={() => onChange(name, opt.value)}
            value={value}
          />
          <label htmlFor={name + opt.value}>{opt.label}</label>
        </div>
      ))}
    </div>
  );
};

export default RadioGroupInput;
